<div class="discover" *ngIf="articles.length">
    <div class="discover__title">{{lang.data[langTitle]}}</div>
    <div class="discover-grid">
        <a class="discover-card pointer"
           *ngFor="let article of articles | slice:0:2"
           routerLink="/article/{{article.slug}}">
<!--            <div class="discover-card-category">{{ article.categoryTitle }}</div>-->
            <div class="discover-card-title">{{ article.title }}</div>
        </a>
    </div>
</div>
